import { Injectable }      from '@angular/core';
import { tokenNotExpired, JwtHelper } from 'angular2-jwt';

import { Fmt } from './fmt.service';

@Injectable()
export class Auth {
  public token: string;
  public jwtHelper: JwtHelper;

  public tokenName: string = 'token';

  constructor(
    public _fmt: Fmt
  ) {
    // Add callback for lock `authenticated` event
    this.token = localStorage.getItem(this.tokenName);

    this.jwtHelper = new JwtHelper();
  }

  public login() {
    // Call the show method to display the widget.
  }

  public authenticated() {
  }

  public CurrentUser(): any {
  }

  public CurrentUserKV(key: string): any {
  }

  public logout(callback: () => void) {
    localStorage.removeItem(this.tokenName);

    // handle callback on remote item
    callback();
  }

  public loggedIn() {
    // this._fmt.log(tokenNotExpired('token'));
    return tokenNotExpired(this.tokenName);
  }

  public decodeToken() {
    this._fmt.log(this.jwtHelper.decodeToken(this.token));
  }

  public getToken(): string {
    return localStorage.getItem(this.tokenName);
  }
}